export var getBlockIndex = function (contentState, blockKey) {
    return contentState.blocks.findIndex(function (block) { return block.key === blockKey; });
};
//# sourceMappingURL=draftUtils.js.map